<template>
  <div class="box" ref="box">
    <div @click="openVideo">
    <div><i class="iconfont iconlujing"></i></div>
    <span>
      {{ timerData.h < 10 ? "0" + timerData.h : timerData.h }}:{{
        timerData.s < 10 ? "0" + timerData.s : timerData.s
      }}
    </span>
    </div>
  </div>
</template>

<script>
import { dragView } from "@/utils";

export default {
  data() {
    return {
      timerData: {
        timing: false,
        timer: null,
        h: 0,
        s: 0,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.dragView(this.$refs.box, this.$refs.box);
    });
  },
  methods: {
    dragView,
    openVideo(){
      this.$parent.openVideo()
    },
    // 计时
    onTiming() {
      this.timerData.timing = true;
      this.timerData.timer = setInterval(() => {
        this.timerData.s = this.timerData.s + 1;
        if (this.timerData.s >= 60) {
          this.timerData.h = this.timerData.h + 1;
          this.timerData.s = 0;
        }
      }, 1000);
    },
    // 关闭定时器
    closeTimer() {
      if (this.timerData.timer) clearInterval(this.timerData.timer);
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  color: #63cf4e;
  position: fixed;
  top: 330px;
  right: calc(50vw - 670px);
  // right: 137px;
  // left: 1565px;
  width: 50px;
  height: 64px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0px 3px 6px 0px rgba($color: #000000, $alpha: .2);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  
  div{
    text-align: center;
    cursor: pointer !important;
  }
}
</style>
